module.exports = __webpack_public_path__ + "static/media/picture-(149).14f1026e.JPG";